import { useScreenSize } from "hooks";
import React from "react";
import Mobile from "./mobile";
import Desktop from "./desktop";

export default function RenderHfProfile() {
  let HfProfileContent;
  const { isDesktop, isMobile } = useScreenSize();
  switch (true) {
    case isDesktop:
      HfProfileContent = <Desktop />;
      break;
    case isMobile:
      HfProfileContent = <Mobile />;
      break;
    default:
      HfProfileContent = <div></div>;
  }
  return HfProfileContent;
}
